import * as React from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { createAuditTrail } from '@actions/agency';
import { logoutRequest } from '@actions/auth';

import { getInstanceWatermark } from '@utils/AppUtil';

import './style.scss';

interface ILink {
  path: string;
  title: string;
}

interface IHeaderProps extends RouteComponentProps<{}> {
  userProfile: IUserProfile;
  logoutRequest: () => void;
  createAuditTrail: TAuditTrailCreateRequest;
  links: ILink[];
}

interface IHeaderState {
  userProfileDropdownVisible: boolean;
}

class Header extends React.Component<IHeaderProps, IHeaderState> {
  constructor(props: IHeaderProps) {
    super(props);

    this.state = {
      userProfileDropdownVisible: false,
    };
  }

  logout = async () => {
    const { history } = this.props;
    await this.props.createAuditTrail({
      activityType: ActivityType.LOGOUT,
      componentType: AuditComponentType.LOGOUT,
    });

    this.props.logoutRequest();
    history.push('/');
  };

  toggleUserProfileDropdownVisibility = () => {
    this.setState((prevState) => ({
      userProfileDropdownVisible: !prevState.userProfileDropdownVisible,
    }));
  };

  renderUserProfileTitle = (): any => {
    const { userProfile } = this.props;

    return (
      <div onClick={this.toggleUserProfileDropdownVisibility} className="app-header__user-name">
        <label>{userProfile.firstName + userProfile.lastName}</label>
        <div className="app-header__user-name-caret" />
      </div>
    );
  };

  renderUserProfileDropdown = () => {
    const className = this.state.userProfileDropdownVisible
      ? 'app-header__user-profile app-header__user-profile--visible'
      : 'app-header__user-profile';

    return (
      <div className={className}>
        {this.renderUserProfileTitle()}
        <div className="app-header__user-actions">
          <label onClick={this.logout}>Logout</label>
        </div>
      </div>
    );
  };

  renderLinks = () => {
    const linkClassName = 'app-header__link';
    const activeLinkClassName = 'app-header__link app-header__link--active';
    const currentWindowPath = this.props.location.pathname;
    const { links } = this.props;

    return (
      <div className="app-header__links-container">
        {links.map((link, index) => (
          <LinkContainer to={link.path} key={index}>
            <a
              className={
                // TODO: Change the method to
                // check the current window path.

                currentWindowPath.includes(link.path) ? activeLinkClassName : linkClassName
              }
            >
              {link.title}
            </a>
          </LinkContainer>
        ))}
      </div>
    );
  };

  render() {
    const headerClassName = 'app-header';
    const instanceWaterMark = getInstanceWatermark();

    return (
      <div className={headerClassName} id="header">
        <div className="app-header__left">
          <LinkContainer to="/">
            <img alt="" src="/assets/logo_white.png" />
          </LinkContainer>
          {this.renderLinks()}
        </div>
        <div className="app-header__right">
          {instanceWaterMark && <div className="instance-watermark">{instanceWaterMark}</div>}
          {this.renderUserProfileDropdown()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  userProfile: state.auth.userProfile,
});

const mapDispatchToProps = (dispatch: any) => ({
  logoutRequest: () => dispatch(logoutRequest()),
  createAuditTrail: (request: IAuditTrailCreateRequest) => dispatch(createAuditTrail(request)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
